import {createAction} from 'redux-actions';

export const saveApiSelectionAction = createAction('SAVE_API_SELECTION');

export const saveApiSelection = (apiSelection) => {
    return saveApiSelectionAction({
        data: {
            apiSelection,
        }
    });
};
